import React, { MouseEvent } from 'react';
import { DurationMap } from 'common/types';

const StayDurationInput = ({
  clickCode,
  editing,
  duration,
  onSelect,
  cx,
}: {
  clickCode: string;
  editing: boolean;
  duration: string;
  onSelect: (e: MouseEvent) => void;
  cx: (classname: string) => string;
}) => {
  return (
    <button
      type="button"
      className={cx('StayDurationInput')}
      role="tab"
      aria-selected={editing}
      aria-checked={!!duration}
      onClick={onSelect}
      data-event-nlog="click"
      data-event-area-code={clickCode}
    >
      <strong className={cx('duration')}>
        {duration ? DurationMap.get(duration) : '체류기간'}
      </strong>
      <i className={cx('sub')}>
        {duration ? '체류기간' : '체류기간을 선택하세요'}
      </i>
    </button>
  );
};

export default StayDurationInput;
